<template>
    <div class="section about-hero fade-in-section">
        <router-link to="/" class="back-link">
            <ArrowLeft :size="20" />
            <span>Back to Home</span>
        </router-link>

        <h1 class="logo">curie</h1>
        <p class="tagline">Empowering HSC Chemistry Students</p>
    </div>
</template>

<script>
import { ArrowLeft } from 'lucide-vue-next';

export default {
    name: 'AboutHeroSection',
    components: {
        ArrowLeft
    }
};
</script>

<style scoped>
.section {
    position: relative;
    z-index: 2;
    padding: 80px 20px;
    max-width: 80vw;
    margin: 0 auto;
    min-height: 60vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid var(--accent);
}

.about-hero {
    text-align: center;
}

.back-link {
    position: absolute;
    top: 40px;
    left: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--accent);
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    transition: transform 0.2s ease;
}

.back-link:hover {
    transform: translateX(-4px);
}

.logo {
    font-family: 'Crimson Pro', 'Times New Roman', serif;
    font-size: 96px;
    font-weight: 400;
    color: var(--accent);
    margin-bottom: 20px;
    letter-spacing: 2px;
}

.tagline {
    font-size: 24px;
    color: var(--text-secondary);
    font-weight: 300;
}

/* Fade-in animation */
.fade-in-section {
    opacity: 0;
    transform: translateY(30px);
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.fade-in-section.is-visible {
    opacity: 1;
    transform: translateY(0);
}

@media (max-width: 768px) {
    .section {
        min-height: 50vh;
        padding: 60px 20px;
    }

    .back-link {
        top: 20px;
    }

    .logo {
        font-size: 64px;
    }

    .tagline {
        font-size: 18px;
    }
}
</style>
